import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { UITableBaseColumn } from '@shared/ui';
import { NzProgressModule } from 'ng-zorro-antd/progress';

interface ParkingLoadData {
  averageLoadInPercent: number;
  differenceInPercent: number;
}

@Component({
  selector: 'aggregator-dashboard-parking-load',
  templateUrl: './parking-load.component.html',
  styleUrl: './parking-load.component.scss',
  standalone: true,
  imports: [NgClass, NzProgressModule],
})
export class DashboardParkingLoadComponent extends UITableBaseColumn {
  get percent(): number {
    return (this.data as ParkingLoadData)?.averageLoadInPercent;
  }

  get difference(): string {
    const value = (this.data as ParkingLoadData)?.differenceInPercent;
    return (value > 0 ? '+' : '-') + value;
  }

  get isDifferenceNegative(): boolean {
    return (this.data as ParkingLoadData)?.differenceInPercent < 0;
  }

  progressFormat = (percent: number): string => percent + '';
}
